/* ═══════════════════════════════════════════════════════════════════════════
   eoh-chat-display.js  ·  Display (chat frontend)

   Fully standalone — NO eoh-chat.js edits. Chains the existing completion hook
   (window.eohOnMessageComplete) and uses a safe childList-only observer for
   history that loads in bulk.

   Features (each gated via GET /chat-inputs/features):
     • Jump-to-latest    (chat_jump_to_latest)  — floating ↓ when scrolled up
     • Long-answer collapse (chat_answer_collapse) — Show more/less on tall replies
     • Mobile table scroll  (chat_table_scroll)  — wrap AI tables in an x-scroll box
     • Limits detail        (chat_limits_detail) — tap the usage bar for a popover

   Load AFTER eoh-chat.js (and after eoh-chat-outputs.js so the hook chains cleanly):
     <script src="{{ 'eoh-chat-display.js' | asset_url }}" defer></script>
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var _dev = window.location.pathname.indexOf('/pages/erp-chat_dev') !== -1
          || window.location.search.indexOf('preview_theme_id=159788171482') !== -1
          || window.location.hostname !== 'erponlinehub.com';
  var API = (window.location.hostname === 'erponlinehub.com' && !_dev)
    ? 'https://erp-ai-backend.vercel.app'
    : 'https://erp-ai-backend-dev.vercel.app';

  // Where the upgrade CTA links (change if your pricing page differs).
  var UPGRADE_URL = '/pages/plans';
  var COLLAPSE_MAX = 900; // px — replies taller than this get a Show more toggle

  var _flags = {};
  function _tok()  { try { return localStorage.getItem('eoh_t') || ''; } catch (_) { return ''; } }
  function _auth() { var h = {}; var t = _tok(); if (t) h['Authorization'] = 'Bearer ' + t; return h; }
  function _esc(s) { return String(s == null ? '' : s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
  async function _getJSON(url) { try { var r = await fetch(url, { headers: _auth() }); if (!r.ok) return null; return await r.json(); } catch (_) { return null; } }

  /* ── per-bubble processing: table wrap + long-answer collapse (idempotent) ── */
  function _wrapTables(bubble) {
    if (_flags.chat_table_scroll === false) return;
    var mb = bubble.querySelector('.mbubble') || bubble;
    mb.querySelectorAll('table').forEach(function (t) {
      var par = t.parentElement;
      if (par && par.classList && par.classList.contains('eoh-tablewrap')) return;
      var w = document.createElement('div');
      w.className = 'eoh-tablewrap';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  }
  function _maybeCollapse(bubble) {
    if (_flags.chat_answer_collapse === false) return;
    var mb = bubble.querySelector('.mbubble');
    if (!mb) return;
    // already handled?
    if (mb.parentNode && mb.parentNode.querySelector('.eoh-collapse-btn')) return;
    if (mb.scrollHeight <= COLLAPSE_MAX) return;
    mb.classList.add('eoh-collapsed');
    mb.style.maxHeight = COLLAPSE_MAX + 'px';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'eoh-collapse-btn'; btn.textContent = 'Show more ▾';
    btn.addEventListener('click', function () {
      var col = mb.classList.toggle('eoh-collapsed');
      mb.style.maxHeight = col ? COLLAPSE_MAX + 'px' : 'none';
      btn.textContent = col ? 'Show more ▾' : 'Show less ▴';
      if (!col) btn.scrollIntoView({ block: 'nearest' });
    });
    if (mb.parentNode) mb.parentNode.insertBefore(btn, mb.nextSibling);
  }
  function _process(bubble) {
    if (!bubble || bubble.nodeType !== 1) return;
    try { _wrapTables(bubble); } catch (_) {}
    try { _maybeCollapse(bubble); } catch (_) {}
  }

  /* ── jump-to-latest FAB ─────────────────────────────────────────────────── */
  function _initJump() {
    if (_flags.chat_jump_to_latest === false) return;
    var msgs = document.getElementById('msgs'); if (!msgs) return;
    if (document.getElementById('eoh-jump-btn')) return;
    var btn = document.createElement('button');
    btn.id = 'eoh-jump-btn'; btn.type = 'button'; btn.title = 'Jump to latest'; btn.innerHTML = '↓';
    btn.style.display = 'none';
    btn.addEventListener('click', function () { msgs.scrollTop = msgs.scrollHeight; });
    (msgs.parentElement || document.body).appendChild(btn);
    var _t = null;
    function _upd() {
      var far = (msgs.scrollHeight - msgs.scrollTop - msgs.clientHeight) > 160;
      btn.style.display = far ? 'flex' : 'none';
    }
    msgs.addEventListener('scroll', function () { if (_t) return; _t = setTimeout(function () { _t = null; _upd(); }, 120); });
  }

  /* ── limits-bar detail popover ──────────────────────────────────────────── */
  function _initLimitsDetail() {
    if (_flags.chat_limits_detail === false) return;
    var bar = document.getElementById('limits-bar'); if (!bar) return;
    bar.style.cursor = 'pointer';
    bar.addEventListener('click', function () {
      var ex = document.getElementById('eoh-limits-pop'); if (ex) { ex.remove(); return; }
      var plan = (window.S && (window.S.plan || (window.S.user && window.S.user.plan))) || '';
      var metrics = Array.prototype.map.call(bar.querySelectorAll('.lim-item, [id^="lim-"], span'), function (n) {
        var t = (n.textContent || '').trim(); return t; })
        .filter(function (t, i, a) { return t && t.length < 40 && a.indexOf(t) === i; }).slice(0, 6);
      var pop = document.createElement('div');
      pop.id = 'eoh-limits-pop';
      pop.innerHTML =
        '<div class="hd">' + (plan ? 'Plan: <b>' + _esc(plan) + '</b>' : 'Your usage') + '</div>' +
        '<div class="mt">' + (metrics.length ? metrics.map(function (m) { return '<div>' + _esc(m) + '</div>'; }).join('') : 'Usage shown in the bar above.') + '</div>' +
        '<a class="up" href="' + UPGRADE_URL + '">Upgrade plan →</a>';
      document.body.appendChild(pop);
      var r = bar.getBoundingClientRect();
      pop.style.top = (r.bottom + 6) + 'px';
      pop.style.left = Math.max(8, r.left) + 'px';
      var close = function (e) { if (pop && !pop.contains(e.target) && e.target !== bar && !bar.contains(e.target)) { pop.remove(); document.removeEventListener('click', close, true); } };
      setTimeout(function () { document.addEventListener('click', close, true); }, 0);
    });
  }

  /* ── styles ─────────────────────────────────────────────────────────────── */
  function _css() {
    if (document.getElementById('eoh-display-css')) return;
    var c = [
      '.eoh-tablewrap{overflow-x:auto;max-width:100%;-webkit-overflow-scrolling:touch}',
      '.mbubble.eoh-collapsed{overflow:hidden;-webkit-mask-image:linear-gradient(#000 72%,transparent);mask-image:linear-gradient(#000 72%,transparent)}',
      '.eoh-collapse-btn{background:var(--bg3,#111a2b);border:1px solid var(--border,#25324a);color:var(--gl,#0a8a5f);border-radius:8px;padding:5px 12px;font-size:12px;cursor:pointer;margin:6px 0 2px;font-family:inherit}',
      '.eoh-collapse-btn:hover{border-color:var(--gl,#0a8a5f)}',
      '#eoh-jump-btn{position:absolute;right:22px;bottom:120px;z-index:40;width:38px;height:38px;border-radius:50%;background:var(--gl,#0a8a5f);color:#fff;border:none;cursor:pointer;font-size:18px;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(0,0,0,.35)}',
      '#eoh-jump-btn:hover{filter:brightness(1.08)}',
      '#eoh-limits-pop{position:fixed;z-index:9999;min-width:190px;max-width:280px;background:var(--bg2,#16202e);border:1px solid var(--border,#25324a);border-radius:10px;padding:12px 14px;box-shadow:0 8px 30px rgba(0,0,0,.4);font-size:12px;color:var(--text,#e8eef5)}',
      '#eoh-limits-pop .hd{font-size:13px;margin-bottom:8px}',
      '#eoh-limits-pop .mt div{color:var(--dim,#9fb0c3);padding:2px 0}',
      '#eoh-limits-pop .up{display:inline-block;margin-top:10px;color:var(--gl,#0a8a5f);text-decoration:none;font-weight:600}'
    ].join('');
    var s = document.createElement('style'); s.id = 'eoh-display-css'; s.textContent = c; document.head.appendChild(s);
  }

  /* ── hooks: chain completion hook + safe history observer ───────────────── */
  function _chainHook() {
    var prev = window.eohOnMessageComplete;
    window.eohOnMessageComplete = function (bubble, data) {
      try { if (typeof prev === 'function') prev(bubble, data); } catch (_) {}
      try { _process(bubble); } catch (_) {}
    };
  }
  function _observeHistory() {
    var msgs = document.getElementById('msgs'); if (!msgs || !window.MutationObserver) return;
    // childList only (NOT subtree) → fires on new/loaded top-level messages, never
    // on streaming text. Bulk-loaded history arrives with full content, so it's
    // measured correctly here; live streamed messages are handled by the hook.
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes || [];
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n && n.nodeType === 1 && n.classList && n.classList.contains('msg')) _process(n);
        }
      }
    }).observe(msgs, { childList: true });
    // one pass over whatever is already on screen
    msgs.querySelectorAll('.msg.assistant').forEach(_process);
  }

  /* ── boot ───────────────────────────────────────────────────────────────── */
  async function _boot() {
    var f = await _getJSON(API + '/chat-inputs/features');
    _flags = (f && f.features) || {};
    _css();
    _chainHook();
    _observeHistory();
    _initJump();
    _initLimitsDetail();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', _boot); else _boot();
})();
